/**
 * United Kingdom Address Format
 */

import type { CountryAddressFormat } from './country-types';

export const GB_ADDRESS_FORMAT: CountryAddressFormat = {
  countryCode: 'GB',
  fields: [
    {
      id: 'name',
      name: 'name',
      type: 'text',
      labelMessageKey: 'address.name',
      placeholderMessageKey: 'address.name',
      defaultRequired: true,
      validation: [{ type: 'required', value: true }],
      layout: {
        componentClassName: 'name-input',
        labelClassName: 'name-label',
      },
    },
    {
      id: 'company',
      name: 'company',
      type: 'text',
      labelMessageKey: 'address.companyName',
      placeholderMessageKey: 'address.companyPlaceholder',
      validation: [],
      layout: {},
    },
    {
      id: 'country',
      name: 'countryCode',
      type: 'select',
      labelMessageKey: 'address.country',
      placeholderMessageKey: 'address.country',
      defaultRequired: true,
      validation: [{ type: 'required', value: true }],
      layout: {},
    },
    {
      id: 'line1',
      name: 'line1',
      type: 'text',
      labelMessageKey: 'address.addressLine1',
      placeholderMessageKey: 'address.addressLine1Placeholder',
      defaultRequired: true,
      validation: [{ type: 'required', value: true }],
      layout: {},
    },
    {
      id: 'line2',
      name: 'line2',
      type: 'text',
      labelMessageKey: 'address.addressLine2',
      placeholderMessageKey: 'address.addressLine2Placeholder',
      validation: [],
      layout: {},
    },
    {
      id: 'line3',
      name: 'line3',
      type: 'text',
      labelMessageKey: 'address.addressLine3',
      placeholderMessageKey: 'address.addressLine3Placeholder',
      validation: [],
      layout: {},
    },
    {
      id: 'city',
      name: 'city',
      type: 'text',
      labelMessageKey: 'address.city',
      placeholderMessageKey: 'address.city',
      defaultRequired: true,
      validation: [{ type: 'required', value: true }],
      layout: {
        isInline: true,
      },
    },
    {
      id: 'county',
      name: 'state',
      type: 'text',
      labelMessageKey: 'address.county',
      placeholderMessageKey: 'address.county',
      validation: [],
      layout: {
        isInline: true,
        componentClassName: 'state-input',
      },
    },
    {
      id: 'postcode',
      name: 'postalCode',
      type: 'postalCode',
      labelMessageKey: 'address.postcode',
      placeholderMessageKey: 'address.postcode',
      defaultRequired: true,
      validation: [{ type: 'required', value: true }],
      layout: {
        isInline: true,
        componentClassName: 'postal-code-input',
        labelClassName: 'postal-code-label',
      },
    },
    {
      id: 'phone',
      name: 'phone',
      type: 'phone',
      labelMessageKey: 'address.phone',
      placeholderMessageKey: 'address.phone',
      defaultRequired: true,
      validation: [{ type: 'required', value: true }],
      layout: {
        componentClassName: 'phone-number',
      },
    },
    {
      id: 'email',
      name: 'email',
      type: 'email',
      labelMessageKey: 'address.email',
      placeholderMessageKey: 'address.email',
      validation: [{ type: 'email', value: true }],
      layout: {},
    },
  ],
};
